


















import { Component, mixins } from '@niknevis/vue-modules'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import AdminCouponCreateForm from '@/modules/coupon/components/admin/forms/AdminCouponCreateForm.vue'
import { Prop } from 'vue-property-decorator'
import { CampaignTypes } from '@/modules/base-campaign/models/base-campaign-resource.model'
import { CouponDiscountUnit, CouponStatus } from '@/modules/coupon/models/coupon-resource.model'

@Component({
  components: {
    AdminCouponCreateForm,
    Modal
  }
})
export default class AdminCreateCouponDialog extends mixins(DialogMixin) {
  @Prop({ required: true }) campaignTypesInPersian: { [key in CampaignTypes]: string }
  @Prop({ required: true }) couponStatuses: { [key in CouponStatus]: string }
  @Prop({ required: true }) couponDiscountUnits: { [key in CouponDiscountUnit]: string }

  $refs: {
    dialog: QDialog
  }

  modalVisibility: boolean = false
}
